import React from 'react';
import PropTypes from 'prop-types';
import TextArea from 'semantic-ui-react/dist/commonjs/addons/TextArea';

import './forminputs.css';

class RenderTextArea extends React.Component {
  inputBlur = (e) => {
    this.props.input.value = e.target.value.trim();
    this.props.input.onBlur(this.props.input.value);
  };

  render() {
    const {
      input,
      labelText,
      rows,
      placeholder,
      meta: { touched, error },
      disabled,
      parentClass,
      noMargin
    } = this.props;
    return (
      <div className={`text-area-wrapper ${parentClass || ''} ${noMargin ? 'noMargin' : ''}`}>
        <label>{labelText}</label>
        <TextArea
          rows={rows}
          {...input}
          onBlur={(e) => this.inputBlur(e)}
          disabled={disabled}
          placeholder={placeholder}
          className="textarea-placeholder"
        />
        {touched && error && <div className="error-msg">{error}</div>}
      </div>
    );
  }
}

RenderTextArea.propTypes = {
  labelText: PropTypes.string,
  rows: PropTypes.string,
  input: PropTypes.any,
  meta: PropTypes.object,
  touched: PropTypes.bool,
  error: PropTypes.string,

  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  parentClass: PropTypes.string,
  noMargin: PropTypes.bool
};

export default RenderTextArea;
